<template>
  <b-form-checkbox v-model='isAllHousehold' class="all-household" data-test="demo-allHousehold">
    {{household.SettingDesc}}
  </b-form-checkbox>
</template>

<script>
  export default {
    computed: {
      isAllHousehold: {
        get () {
          return this.$store.state.order.DemoType === 99
        },
        set (val) {
          if (val) {
            this.$store.commit('order/setAllHouseholds')
          } else {
            this.$store.commit('order/setUnAllHouseholds')
          }
        }
      },
      household () {
        return this.$store.state.demo.allHouseholdSetting || {}
      }
    }
  }
</script>

<style scoped lang="scss">
  .all-household {
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/MDemoAllCheck.vue